// src/components/common/InfoIcon/InfoIcon.jsx
import React from 'react';
import { Info } from 'lucide-react';
import styles from './InfoIcon.module.css';

/**
 * Small hover/keyboard-focus tooltip icon for card and section headers.
 *
 * @param {Object} props
 * @param {string} props.text - Tooltip content (required)
 * @param {number} [props.size] - Icon size (default 14)
 * @param {'top'|'bottom'|'left'|'right'} [props.placement] - Bubble placement (default 'top')
 * @param {string} [props.className] - Additional CSS class
 */
const InfoIcon = ({ text, size = 14, placement = 'top', className = '' }) => {
  if (!text) return null;

  return (
    <span
      className={`${styles.infoIconWrapper} ${className}`}
      data-placement={placement}
      tabIndex={0}
      aria-label={text}
    >
      <Info size={size} className={styles.infoIcon} />
      <span className={styles.tooltipBubble} role="tooltip">{text}</span>
    </span>
  );
};

export default InfoIcon;
